import { render, staticRenderFns } from "./BottomNavLink.vue?vue&type=template&id=e2f6bb1a&"
import script from "./BottomNavLink.vue?vue&type=script&lang=ts&"
export * from "./BottomNavLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports